import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=10cd713b&scoped=true"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"
import style0 from "./PersonalInformation.vue?vue&type=style&index=0&id=10cd713b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd713b",
  null
  
)

export default component.exports